import { useQuery } from "@tanstack/react-query";
import { getCustomerSupportFaqReadFaqListapi } from "../../../../api/support/faq";

export const useGetCustomerSupportFaqReadFaqList = (
  topicTypeIdx: number | null
) => {
  return useQuery({
    queryKey: ["getCustomerSupportFaqReadFaqList", topicTypeIdx],
    queryFn: () => getCustomerSupportFaqReadFaqListapi(topicTypeIdx),
    select: (res) => res?.result,
    enabled: !!topicTypeIdx, // ✅ null일 땐 호출 안 함
  });
};
